import React from 'react';
import { CopyIcon, DownloadIcon, MailIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { BottomSheet } from './BottomSheet';
import { business } from '../data/business';
import { copyText, downloadVCard } from '../utils/contact';
interface ContactSheetProps {
  open: boolean;
  onClose: () => void;
  onToast: (mensagem: string) => void;
}
export function ContactSheet({
  open,
  onClose,
  onToast
}: ContactSheetProps) {
  const copiar = async (valor: string, rotulo: string) => {
    const ok = await copyText(valor);
    onToast(ok ? `${rotulo} copiado` : 'Não foi possível copiar');
  };
  const campos = [{
    icone: PhoneIcon,
    rotulo: 'Telefone',
    valor: business.telefoneExibicao,
    copia: business.telefoneE164
  }, {
    icone: MailIcon,
    rotulo: 'E-mail',
    valor: business.email,
    copia: business.email
  }, {
    icone: MapPinIcon,
    rotulo: 'Endereço',
    valor: `${business.endereco} · ${business.complemento}`,
    copia: `${business.endereco}, ${business.complemento}`
  }];
  return <BottomSheet open={open} onClose={onClose} title="Salvar contato" subtitle="Adicione à agenda ou copie os dados" data-id="element-47" data-mp="1x99xp6bvvev6">
      <button type="button" onClick={() => {
      downloadVCard(business);
      onToast('Contato baixado (.vcf)');
    }} className="mt-2 flex w-full items-center justify-between rounded-2xl bg-ink px-5 py-4 text-cream transition-[background-color,transform] duration-150 ease-out hover:bg-[#3f352c] active:scale-[0.985] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-mocha" data-id="element-48" data-mp="1sbgrweehsmvf">
        <span data-id="element-49" data-mp="2pwcu9sx01fis">
          <span className="block text-[15px] font-medium" data-id="element-50" data-mp="2pyyz3ksi9gxb">Adicionar à agenda</span>
          <span className="block text-[12px] text-cream/65" data-id="element-51" data-mp="2kyba14nu7a5q">Arquivo de contato para iPhone e Android</span>
        </span>
        <DownloadIcon className="h-5 w-5" strokeWidth={1.6} data-id="element-52" data-mp="2yvhnqktpeio3" />
      </button>

      <ul className="mt-4 divide-y divide-shell overflow-hidden rounded-2xl border border-shell bg-white/60" data-id="element-53" data-mp="2u02g4amahj04">
        {campos.map(campo => {
        const Icone = campo.icone;
        return <li key={campo.rotulo} className="flex items-center gap-3 px-4 py-3.5" data-id="element-54" data-mp="1wkefkdyofito">
              <Icone className="h-4 w-4 shrink-0 text-mocha" strokeWidth={1.6} data-id="element-55" data-mp="20kye9lyweuhx" />
              <span className="min-w-0 flex-1" data-id="element-56" data-mp="25cq7y5dcpgca">
                <span className="block text-[11px] uppercase tracking-wider text-muted" data-id="element-57" data-mp="25eko76dogka1">
                  {campo.rotulo}
                </span>
                <span className="block truncate text-[13.5px] text-ink" data-id="element-58" data-mp="2f9us5znmz1qg">{campo.valor}</span>
              </span>
              <button type="button" onClick={() => copiar(campo.copia, campo.rotulo)} aria-label={`Copiar ${campo.rotulo.toLowerCase()}`} className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-sand text-ink transition-colors duration-150 ease-out hover:bg-shell active:bg-shell focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-mocha" data-id="element-59" data-mp="2kasbifkdu1tj">
                <CopyIcon className="h-4 w-4" strokeWidth={1.6} data-id="element-60" data-mp="hmtnhz0d2g8m" />
              </button>
            </li>;
      })}
      </ul>

      <a href={`tel:${business.telefoneE164}`} className="mt-3 flex w-full items-center justify-center gap-2 rounded-2xl border border-shell bg-white/60 py-3.5 text-[14px] font-medium text-ink transition-colors duration-150 ease-out hover:border-mocha/30 hover:bg-white active:bg-sand focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-mocha" data-id="element-61" data-mp="co8og2wui2lr">
        <PhoneIcon className="h-4 w-4 text-mocha" strokeWidth={1.6} data-id="element-62" data-mp="we2jcpuuwxu7" />
        Ligar agora
      </a>
    </BottomSheet>;
}